import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

export function useTripFinderShellBehavior({
  showModal,
  isSearchEnabled,
}) {
  const showAdventure = ref(false);
  const isRefineOpen = ref(false);
  const currentFilterCount = ref(0);
  const desktopModalTop = ref(64);
  const refineButtonRef = ref(null);

  const bodyScrollY = ref(0);
  const isBodyLocked = ref(false);

  const refineDropdownStyle = computed(() => ({
    maxWidth: '96vw',
    width: '96vw',
  }));

  const desktopModalStyle = computed(() => {
    const topPx = `${desktopModalTop.value}px`;

    return {
      top: topPx,
      maxHeight: `calc(100vh - ${topPx})`,
    };
  });

  const handleFilterCountUpdate = (count) => {
    currentFilterCount.value = count;
  };

  const closeRefinePanels = () => {
    isRefineOpen.value = false;
    showAdventure.value = false;
  };

  const closeMobileRefinePanels = () => {
    showAdventure.value = false;
  };

  const toggleDesktopRefine = () => {
    isRefineOpen.value = !isRefineOpen.value;
  };

  const isMobileScreen = () => typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(max-width: 767px)').matches;

  const lockBodyScroll = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined' || isBodyLocked.value) return;

    bodyScrollY.value = window.scrollY || window.pageYOffset || 0;

    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${bodyScrollY.value}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.classList.add('tripfinder-modal-open');
    isBodyLocked.value = true;
  };

  const unlockBodyScroll = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !isBodyLocked.value) return;

    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.classList.remove('tripfinder-modal-open');

    window.scrollTo(0, bodyScrollY.value || 0);
    isBodyLocked.value = false;
  };

  const updateDesktopModalPosition = () => {
    if (typeof document === 'undefined') return;

    const headerEl = document.querySelector('header');
    if (!headerEl) {
      desktopModalTop.value = 64;
      return;
    }

    const rect = headerEl.getBoundingClientRect();
    desktopModalTop.value = Math.max(0, Math.round(rect.bottom));
  };

  watch(isSearchEnabled, (enabled) => {
    if (enabled) return;
    closeRefinePanels();
  });

  watch(showModal, async (open) => {
    if (open) {
      await nextTick();
      updateDesktopModalPosition();

      if (isMobileScreen()) {
        lockBodyScroll();
      }

      return;
    }

    unlockBodyScroll();
  });

  onMounted(() => {
    window.addEventListener('resize', updateDesktopModalPosition);

    nextTick(() => updateDesktopModalPosition());

    if (showModal.value && isMobileScreen()) {
      lockBodyScroll();
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateDesktopModalPosition);
    unlockBodyScroll();
  });

  return {
    closeMobileRefinePanels,
    currentFilterCount,
    desktopModalStyle,
    handleFilterCountUpdate,
    isRefineOpen,
    refineButtonRef,
    refineDropdownStyle,
    showAdventure,
    toggleDesktopRefine,
  };
}
